<script setup lang="ts">
import CategoryCard from './components/CategoryCard.vue'
import ContactSupportSection from './components/ContactSupportSection.vue'
import HelpCenterSearch from './components/HelpCenterSearch.vue'

definePageMeta({
  layout: 'pusat-bantuan',
})

useHead({
  title: 'Pusat Bantuan - Rintisan Billing',
})

const { categories, searchArticles } = usePusatBantuanData()

const searchQuery = ref('')
const searchResults = computed(() => {
  if (!searchQuery.value.trim())
    return []
  return searchArticles(searchQuery.value)
})
const showSearchResults = computed(() => searchQuery.value.trim().length > 0)
</script>

<template>
  <div class="container mx-auto px-4 py-8 space-y-6">
    <Card class="p-6 space-y-6">
      <!-- Title Section -->
      <div>
        <h1 class="text-xl font-semibold">
          Panduan Pengguna Rintisan Billing
        </h1>
        <p class="mt-2">
          Temukan jawaban atas pertanyaan paling umum seputar penggunaan Rintisan Billing. Jika Anda tidak menemukan jawaban yang Anda cari, jangan ragu untuk menghubungi tim dukungan kami.
        </p>
      </div>

      <!-- Search -->
      <div class="max-w-md">
        <HelpCenterSearch
          v-model="searchQuery"
          placeholder="Pilih topik sesuai kebutuhan Anda"
        />
      </div>

      <!-- Search Results -->
      <div v-if="showSearchResults" class="mb-10">
        <p class="text-sm text-neutral-500 mb-4">
          {{ searchResults.length }} hasil ditemukan untuk "{{ searchQuery }}"
        </p>
        <div v-if="searchResults.length" class="space-y-2">
          <NuxtLink
            v-for="article in searchResults"
            :key="article.slug"
            :to="`/pusat-bantuan/${article.category}/${article.tab}/${article.slug}`"
            class="block p-4 rounded-lg border border-neutral-200 hover:border-primary/30 transition-colors"
          >
            <p class="text-sm font-medium text-neutral-800">
              {{ article.question }}
            </p>
            <p class="text-xs text-neutral-400 mt-1">
              {{ categories.find(c => c.slug === article.category)?.title }}
            </p>
          </NuxtLink>
        </div>
        <p v-else class="text-sm text-neutral-400">
          Tidak ada hasil yang ditemukan. Coba kata kunci lain atau hubungi tim support kami.
        </p>
      </div>

      <!-- Category Grid -->
      <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <CategoryCard
          v-for="category in categories"
          :key="category.slug"
          :icon="category.icon"
          :title="category.title"
          :description="category.description"
          :to="`/pusat-bantuan/${category.slug}`"
        />
      </div>
    </Card>

    <!-- Contact Support -->
    <ContactSupportSection />
  </div>
</template>
